var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 945.469 945.469",
    style: {
      enableBackground: "new 0 0 945.469 945.469"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.348 944.29 183.3-60.1c6.7-2.2 12.8-5.9 17.7-10.9l429.6-432.1-171.101-171.2-428.5 431c-5.6 5.7-9.6 12.8-11.6 20.601l-49.2 195c-4.399 17.5 12.601 33.399 29.801 27.699z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m921.748 102.49-86.601-86.6c-20.899-20.9-63.3-21.2-83.8-.8l-211.2 212.4 171.2 171.2 66.5-66.9 32.4 32.6c7.8 7.8 7.7 20.5 0 28.3l-52.5 52.4-42.5 42.399-177.9 177.4c-15.6 15.6-15.7 40.899-.1 56.6 7.8 7.8 18.1 11.7 28.3 11.7s20.4-3.9 28.3-11.7l272.9-272.3c39-38.9 39.1-102.3.2-141.3l-32.7-32.9 88.2-88.7c20.501-20.498 20.2-62.898-.699-83.799z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.c662baad882f85c7f996f895d11776a0.svg";
export { ForwardRef as ReactComponent };